import React from "react";
import { styled } from "@mui/material/styles";
import { AddNewItemButton } from "../workout/AddNewItemButton";

const StyledListbox = styled("ul")(({ theme }) => ({
  margin: 0,
  padding: 0,
  listStyle: "none",
  maxHeight: 250,
  overflow: "auto",
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[4],
  position: "relative",
}));

interface ListboxTagWithFooterComponentProps
  extends React.HTMLAttributes<HTMLElement> {
  children?: React.ReactNode;
  manageTags?: () => void;
  onlySelectAllowed?: boolean;
  disableAddNewTag?: boolean;
}

const ListboxTagWithFooterComponent = React.forwardRef<
  HTMLUListElement,
  ListboxTagWithFooterComponentProps
>(function ListboxExerciseFooterComponent(props, ref) {
  const {
    children,
    manageTags,
    onlySelectAllowed,
    disableAddNewTag,
    ...other
  } = props;

  return (
    <>
      <StyledListbox ref={ref} {...other}>
        {children}
      </StyledListbox>

      {!onlySelectAllowed && (
        <AddNewItemButton
          handleClick={manageTags}
          disabled={disableAddNewTag}
          text="Manage tags"
        />
      )}
    </>
  );
});

export default ListboxTagWithFooterComponent;
